




































import { Button, SortableTable } from "@micad/vue-components";

import { defineComponent, reactive, watch } from "@vue/composition-api";
import Loading from "@/components/Loading.vue";
import router from "@/router";
import { TableFilter } from "@micad/vue-components/src/common/interfaces";
import { userProfiles } from "@/data/repos/userProfiles";
import { UserProfile } from "@/data/repos/commonModels";
import { canIUse } from "@/modules/auth";

const profileColumns = [
  {
    name: "name",
    label: "Profile name",
    align: "left",
    field: (row: UserProfile) => row.name,
    classes: "primary",
    sortable: true,
    filter: false,
    customBodyRender: (row: UserProfile) =>
      `<p class="hover:cursor-pointer">${row.name}</p>`,
  },
  {
    name: "description",
    label: "Description",
    align: "left",
    showMobile: "top",
    mobilePosition: 2,
    field: (row: UserProfile) => row.description,
    sortable: true,
  },
  {
    name: "role",
    label: "Role",
    align: "left",
    showMobile: "top",
    mobilePosition: 1,
    field: (row: UserProfile) => row.role,
    sortable: true,
  },
  {
    name: "applications",
    label: "Applications",
    align: "left",
    showMobile: "bottom",
    mobilePosition: 2,
    field: (row: UserProfile) => row.applications?.join(", "),
    sortable: true,
  },
  {
    name: "id",
    label: "",
    align: "left",
    field: (row: UserProfile) => row.id,
    filter: false,
    customBodyRender: () =>
      canIUse("UserProfiles_rw")
        ? `<button class="custom-button full-width" title="Edit">Edit</button>`
        : "",
  },
];
interface UserColumn {
  id: number | string;
  name: string;
  description: string;
  role: string;
  apps: string;

  classes: string;
  sortable: boolean;
  filter: boolean;
  customBodyRender: boolean;
  value: unknown;
}

const filters = [
  {
    name: "name",
    label: "Profile name",
    type: "text",
    value: "",
  },
  {
    name: "description",
    label: "Description",
    type: "text",
    value: "",
  },
  {
    name: "role",
    label: "Role",
    type: "text",
    value: "",
  },
];

export default defineComponent({
  name: "ProfileList",
  components: {
    SortableTable,
    Button,
    Loading,
  },
  methods: {
    canIUse,
    applyFilters: async function (filters: TableFilter[]) {
      let profiles = this.state.allProfiles;
      this.state.loaded = false;

      let rowSearch = function (column: string, searchValue: string) {
        return (column || "").toLowerCase().indexOf(searchValue) > -1;
      };

      filters.forEach(function (filter: TableFilter) {
        let searchValue = "";
        let sendValue = filter.sendValue;

        switch (filter.name) {
          case "name":
            searchValue = String(sendValue || "").toLowerCase();
            if (searchValue != "") {
              profiles = profiles.filter((row) =>
                rowSearch(row.name || "", searchValue)
              );
            }
            break;

          case "role":
            searchValue = String(sendValue || "").toLowerCase();
            if (searchValue != "") {
              profiles = profiles.filter((row) =>
                rowSearch(row.role, searchValue)
              );
            }
            break;

          case "description":
            searchValue = String(sendValue || "").toLowerCase();
            if (searchValue != "") {
              profiles = profiles.filter((row) =>
                rowSearch(row.description || "", searchValue)
              );
            }
            break;
        }
      });

      this.state.profiles = profiles;
      this.state.loaded = true;
    },
  },
  setup(props, ctx) {
    watch(
      () => ctx.root.$route,
      () => {
        if (
          router.currentRoute.name === "Home" &&
          router.currentRoute.params.refresh === "true"
        ) {
          refresh();
        }
      }
    );
    const state = reactive({
      profiles: [] as UserProfile[],
      allProfiles: [] as UserProfile[],
      loaded: false,
      progress: false,
      filters,
    });
    function refresh() {
      state.progress = true;
      userProfiles(false).then((data) => {
        if (data.ok) {
          const profiles = data.payload || [];
          state.profiles = state.allProfiles = profiles;
        }
        state.loaded = true;
        state.progress = false;
      });
    }
    refresh();
    function goToCreateUserProfile() {
      router.push({ name: "UserProfileCreate" });
    }
    async function actions(col: UserColumn) {
      switch (col.name) {
        case "name":
          let id: string | number = 0;
          state.profiles.forEach((u) => {
            if (u.name === col.value) id = u.id || "";
          });
          await router.push({
            name: "UserProfileEdit",
            params: { id: String(id) },
          });
          break;
        case "id":
          console.log("col.value:", col.value);
          await router.push({
            name: "UserProfileEdit",
            params: { id: String(col.value) },
          });
          break;
      }
    }
    return { state, goToCreateUserProfile, actions, profileColumns };
  },
});
